// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  addTBScreening,
  deleteTBScreening,
  updateTBScreening,
} from '../../../actions/testingActions';

import TBScreeningForm from './TBScreeningForm.jsx';
import SimpleTable from '../../SimpleTable.jsx';
import Modal from '../../Modal.jsx';
import { Button, PrimaryButton, DeleteButton } from '../../Buttons.jsx';

type Props = {
  tbScreenings: Object[],
  dob: string,
  activePatientId: string,
  activeAccount: Object,
  addTBScreening: Function,
  deleteTBScreening: Function,
  updateTBScreening: Function,
  print: boolean,
}

type State = {
  modalOpen: bool,
  viewOnly: bool,
  editRow: ?Object,
}

class TBScreeningsComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      modalOpen: false,
      viewOnly: false,
      editRow: null,
    };
  }

  // Modal state handlers. editRow is set to row object if editing, else null.
  handleEditRow = (row: Object) => {
    this.setState({
      modalOpen: true,
      viewOnly: false,
      editRow: row,
    });
  }

  handleViewRow = (row: Object) => {
    this.setState({
      modalOpen: true,
      viewOnly: true,
      editRow: row,
    });
  }

  handleAddRow = () => {
    this.setState({
      modalOpen: true,
      viewOnly: false,
      editRow: null,
    });
  }

  closeModal = () => {
    this.setState({
      modalOpen: false,
      editRow: null,
    });
  }

  // Misc functions
  /* eslint-disable no-param-reassign */
  transformData(formValues: Object) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY').toISOString();
    // add active account for edit history
    const { activeAccount } = this.props;
    formValues.editor = `${activeAccount.name}, ${activeAccount.credential}`;
    formValues.editDate = moment().toISOString();
  }

  getAge(item: Object) {
    const dob = moment(this.props.dob);
    const date = moment(item.date);
    const years = date.diff(dob, 'years');
    dob.add(years, 'years');
    const months = date.diff(dob, 'months');
    return `${years} y, ${months} m`;
  }

  // Endpoint action handlers
  handleDeleteRow = (id: string) => {
    this.props.deleteTBScreening(this.props.activePatientId, id);
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformData(formData.values);
    this.props.updateTBScreening(this.props.activePatientId, {
      testId: id,
      ...formData.values,
    });
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformData(formData.values);
    this.props.addTBScreening(this.props.activePatientId, formData.values);
  }

  // Create action column for each row
  actionsAccessor = (row: Object) => {
    const defaultButtons = (
      <div>
        <Button onClick={() => this.handleViewRow(row)}>View</Button>
        <PrimaryButton onClick={() => this.handleEditRow(row)}>Edit</PrimaryButton>
        <DeleteButton onClick={() => this.handleDeleteRow(row._id)}>X</DeleteButton>
      </div>
    );
    return defaultButtons;
  }

  render() {
    let { tbScreenings } = this.props;
    tbScreenings = tbScreenings.map((item, index) => ({ testNum: tbScreenings.length - index, ...item }));

    const columns = [
      {
        Header: '',
        id: 'index',
        accessor: item => `Screening #${item.testNum ? item.testNum : ''}`,
        width: 110,
      },
      {
        Header: 'Date',
        id: 'date',
        accessor: item => (item.date ? moment(item.date).format() : '--'),
      },
      {
        Header: 'Age',
        id: 'age',
        accessor: item => this.getAge(item),
      },
      {
        Header: 'Result',
        id: 'positive',
        accessor: 'positive',
      },
    ];

    if (!this.props.print) {
      columns.push({
        Header: 'Actions',
        id: 'actions',
        maxWidth: 120,
        accessor: this.actionsAccessor,
      });
    }

    if (this.props.print && !tbScreenings.length) {
      return 'No data';
    }

    return (
      <div>
        {!this.props.print && <PrimaryButton onClick={this.handleAddRow}>Add Row</PrimaryButton>}
        <SimpleTable
          columns={columns}
          data={tbScreenings}
        />
        <Modal isOpen={this.state.modalOpen}>
          <TBScreeningForm
            viewOnly={this.state.viewOnly}
            editRow={this.state.editRow}
            handleSaveRow={this.handleSaveRow}
            handleSaveNewRow={this.handleSaveNewRow}
            closeModal={this.closeModal}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tbScreenings: state.patient.data.testing.tbScreenings,
  dob: state.patient.data.generalInfo.dob,
  activeAccount: state.account.activeAccount,
  activePatientId: state.patient.data.activePatientId,
  print: state.patient.print,
});

const mapDispatchToProps = dispatch => ({
  addTBScreening:
   (patientId, tbScreening) => dispatch(addTBScreening(patientId, tbScreening)),
  deleteTBScreening:
   (patientId, tbScreeningId) => dispatch(deleteTBScreening(patientId, tbScreeningId)),
  updateTBScreening:
   (patientId, tbScreening) => dispatch(updateTBScreening(patientId, tbScreening)),
});

const TBScreenings = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TBScreeningsComponent);

export default TBScreenings;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/testing/TBScreenings.jsx